<div class="dashboard-container">
  <!-- Header -->
  <app-staff-header [currentUser]="currentUser" (logout)="onLogout()">
  </app-staff-header>

  <!-- Main Content -->
  <div class="dashboard-content">
    <!-- Navigation -->
    <app-staff-nav [isMobileMenuOpen]="isMobileMenuOpen" (navigate)="onNavigate($event)"
      (closeMobileMenu)="closeMobileMenu()">
    </app-staff-nav>

    <!-- Content Area -->
    <div class="dashboard-main">
      <div class="main-content">
        <!-- Page Header -->
        <div class="content-header">
          <div class="d-flex justify-content-between align-items-center">
            <div>
              <h1 class="page-title">รายละเอียด CPD Course</h1>
              <p class="page-subtitle">ข้อมูลการลงทะเบียนและเรียนคอร์ส CPD Hours</p>
            </div>
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>กลับ
            </button>
          </div>
        </div>

        <!-- Success Alert -->
        @if (successMessage) {
        <ngb-alert type="success" [dismissible]="true" (closed)="successMessage = null" class="mb-3">
          <i class="bi bi-check-circle me-2"></i>{{ successMessage }}
        </ngb-alert>
        }

        <!-- Error Alert -->
        <ngb-alert *ngIf="error" type="danger" [dismissible]="true" (closed)="error = null" class="mb-3">
          <i class="bi bi-exclamation-triangle me-2"></i>{{ error }}
        </ngb-alert>

        <!-- CPD Course Detail Content -->
        <div *ngIf="cpdDetail" class="detail-container">
          <!-- User Information Card -->
          <div class="card mb-4">
            <div class="card-header bg-primary text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-person-circle me-2"></i>ข้อมูลผู้ใช้
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">อีเมล:</label>
                    <div class="info-value">{{ cpdDetail.user.email }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">เลขบัตรประชาชน:</label>
                    <div class="info-value font-monospace">{{ cpdDetail.user.cid }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">User ID:</label>
                    <div class="info-value text-muted">{{ cpdDetail.user.id }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">สถานะบัญชี:</label>
                    <div class="info-value">
                      <span class="badge" [ngClass]="getActiveStatusBadgeClass(cpdDetail.user.isActive)">
                        {{ getActiveStatusText(cpdDetail.user.isActive) }}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Course Information Card -->
          <div class="card mb-4 course-card">
            <div class="card-header bg-gradient-green text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-mortarboard-fill me-2"></i>ข้อมูลคอร์ส
              </h5>
              <p class="mb-0 mt-1" style="font-size: 0.9rem; opacity: 0.9;">
                <i class="bi bi-info-circle me-1"></i>รายละเอียดเกี่ยวกับคอร์สอบรม/สัมมนา
              </p>
            </div>
            <div class="card-body p-4">
              <!-- Course Title Section -->
              <div class="course-title-section mb-4">
                <div class="d-flex align-items-start">
                  <div class="course-icon me-3">
                    <i class="bi bi-book-fill"></i>
                  </div>
                  <div class="flex-grow-1">
                    <label class="course-label">ชื่อคอร์ส</label>
                    <h4 class="course-title mb-0">{{ cpdDetail.course.title }}</h4>
                  </div>
                </div>
              </div>

              <!-- Course Description -->
              <div class="course-description-section mb-4">
                <div class="d-flex align-items-start">
                  <div class="course-icon me-3">
                    <i class="bi bi-file-text-fill"></i>
                  </div>
                  <div class="flex-grow-1">
                    <label class="course-label">คำอธิบาย</label>
                    <p class="course-description mb-0">{{ cpdDetail.course.description }}</p>
                  </div>
                </div>
              </div>

              <!-- Course Details Grid -->
              <div class="row g-3">
                <!-- Instructor -->
                <div class="col-md-6">
                  <div class="course-detail-item">
                    <div class="detail-icon bg-purple">
                      <i class="bi bi-person-badge-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">ผู้สอน</label>
                      <div class="detail-value">{{ cpdDetail.course.instructor }}</div>
                    </div>
                  </div>
                </div>

                <!-- Duration -->
                <div class="col-md-6">
                  <div class="course-detail-item">
                    <div class="detail-icon bg-blue">
                      <i class="bi bi-clock-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">ระยะเวลา</label>
                      <div class="detail-value">
                        <span class="badge bg-primary badge-lg">
                          <i class="bi bi-hourglass-split me-1"></i>
                          {{ cpdDetail.course.duration }} ชั่วโมง
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Category -->
                <div class="col-md-6">
                  <div class="course-detail-item">
                    <div class="detail-icon bg-teal">
                      <i class="bi bi-grid-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">หมวดหมู่</label>
                      <div class="detail-value">
                        <span class="badge bg-info badge-lg">
                          <i class="bi bi-tag-fill me-1"></i>
                          {{ cpdDetail.course.category }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Level -->
                <div class="col-md-6">
                  <div class="course-detail-item">
                    <div class="detail-icon bg-orange">
                      <i class="bi bi-bar-chart-fill"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">ระดับ</label>
                      <div class="detail-value">
                        <span class="badge badge-lg" [ngClass]="getLevelBadgeClass(cpdDetail.course.level)">
                          <i class="bi bi-star-fill me-1"></i>
                          {{ getLevelText(cpdDetail.course.level) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Price -->
                <div class="col-md-6">
                  <div class="course-detail-item highlight">
                    <div class="detail-icon bg-green">
                      <i class="bi bi-cash-coin"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">ราคา</label>
                      <div class="detail-value price-value">
                        <i class="bi bi-currency-dollar me-1"></i>
                        {{ formatPrice(cpdDetail.course.price) }} บาท
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Status -->
                <div class="col-md-6">
                  <div class="course-detail-item">
                    <div class="detail-icon bg-indigo">
                      <i class="bi bi-toggle-on"></i>
                    </div>
                    <div class="detail-content">
                      <label class="detail-label">สถานะคอร์ส</label>
                      <div class="detail-value">
                        <span class="badge badge-lg" [ngClass]="getActiveStatusBadgeClass(cpdDetail.course.isActive)">
                          <i class="bi bi-circle-fill me-1" style="font-size: 0.5rem;"></i>
                          {{ getActiveStatusText(cpdDetail.course.isActive) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Course Schedule Section -->
              <div class="course-schedule-section mt-4">
                <h6 class="section-title">
                  <i class="bi bi-calendar-range me-2"></i>ระยะเวลาการจัดอบรม
                </h6>
                <div class="row g-3">
                  <div class="col-md-6">
                    <div class="schedule-item">
                      <div class="schedule-icon">
                        <i class="bi bi-calendar-check-fill"></i>
                      </div>
                      <div class="schedule-content">
                        <label class="schedule-label">วันเริ่มคอร์ส</label>
                        <div class="schedule-value">{{ formatDate(cpdDetail.course.startDate) }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="schedule-item">
                      <div class="schedule-icon">
                        <i class="bi bi-calendar-x-fill"></i>
                      </div>
                      <div class="schedule-content">
                        <label class="schedule-label">วันสิ้นสุดคอร์ส</label>
                        <div class="schedule-value">{{ formatDate(cpdDetail.course.endDate) }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Enrollment Stats Section -->
              <div class="enrollment-stats-section mt-4">
                <h6 class="section-title">
                  <i class="bi bi-people-fill me-2"></i>สถิติการลงทะเบียน
                </h6>
                <div class="row g-3">
                  <div class="col-md-6">
                    <div class="stat-card">
                      <div class="stat-icon bg-primary">
                        <i class="bi bi-person-plus-fill"></i>
                      </div>
                      <div class="stat-content">
                        <div class="stat-label">จำนวนที่นั่งทั้งหมด</div>
                        <div class="stat-value">{{ cpdDetail.course.seat }}</div>
                        <div class="stat-unit">ที่นั่ง</div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="stat-card">
                      <div class="stat-icon bg-success">
                        <i class="bi bi-person-check-fill"></i>
                      </div>
                      <div class="stat-content">
                        <div class="stat-label">ลงทะเบียนแล้ว</div>
                        <div class="stat-value">{{ cpdDetail.course.regisSeat }}</div>
                        <div class="stat-unit">คน</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- CPD Hours Information Card -->
          <div class="card mb-4">
            <div class="card-header bg-warning text-dark">
              <h5 class="card-title mb-0">
                <i class="bi bi-clock-history me-2"></i>ข้อมูล CPD Hours
              </h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <div class="info-item">
                    <label class="info-label">หัวข้อการศึกษา:</label>
                    <div class="info-value fw-bold">{{ cpdDetail.sessionTitle }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">ชั่วโมงที่ศึกษา:</label>
                    <div class="info-value">
                      <span class="badge bg-primary fs-6">{{ cpdDetail.hoursStudied }} ชั่วโมง</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">วันที่ศึกษา:</label>
                    <div class="info-value">{{ formatDate(cpdDetail.studyDate) }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">ปี:</label>
                    <div class="info-value">{{ cpdDetail.year }}</div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="info-item">
                    <label class="info-label">ความคืบหน้า:</label>
                    <div class="info-value">
                      <div class="progress" style="height: 25px;">
                        <div class="progress-bar" role="progressbar" [style.width.%]="cpdDetail.progress"
                          [attr.aria-valuenow]="cpdDetail.progress" aria-valuemin="0" aria-valuemax="100">
                          {{ cpdDetail.progress }}%
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="info-item">
                    <label class="info-label">หมายเหตุ:</label>
                    <div class="info-value">{{ cpdDetail.notes }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Learning Evidence Card -->
          <div class="card shadow-sm mb-4 evidence-card">
            <div class="card-header bg-gradient-indigo text-white">
              <h5 class="mb-0">
                <i class="bi bi-image me-2"></i>ดูหลักฐานการเรียน
              </h5>
              <p class="mb-0 mt-1" style="font-size: 0.9rem; opacity: 0.9;">
                <i class="bi bi-info-circle me-1"></i>รูปภาพหลักฐานการเข้าเรียนคอร์ส
              </p>
            </div>
            <div class="card-body p-4">
              <div *ngIf="cpdDetail.imageThumbnail" class="evidence-container">
                <div class="evidence-preview">
                  <div class="image-wrapper">
                    <img [src]="cpdDetail.imageThumbnail" alt="หลักฐานการเรียน" class="evidence-image"
                      (click)="openImagePreview(cpdDetail.imageThumbnail)">
                    <div class="image-overlay">
                      <button type="button" class="btn btn-light btn-preview"
                        (click)="openImagePreview(cpdDetail.imageThumbnail)">
                        <i class="bi bi-zoom-in me-2"></i>ดูภาพขนาดใหญ่
                      </button>
                    </div>
                  </div>
                  <div class="evidence-info mt-3">
                    <div class="d-flex align-items-center justify-content-between">
                      <div class="info-text">
                        <i class="bi bi-check-circle-fill text-success me-2"></i>
                        <span class="text-success fw-bold">มีหลักฐานการเรียน</span>
                      </div>
                      <button type="button" class="btn btn-primary btn-sm"
                        (click)="openImagePreview(cpdDetail.imageThumbnail)">
                        <i class="bi bi-eye me-1"></i>ดูรูปภาพ
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div *ngIf="!cpdDetail.imageThumbnail" class="evidence-empty">
                <div class="empty-state">
                  <div class="empty-icon">
                    <i class="bi bi-image-fill"></i>
                  </div>
                  <h6 class="empty-title">ไม่มีหลักฐานการเรียน</h6>
                  <p class="empty-text">ยังไม่มีการอัปโหลดรูปภาพหลักฐานการเข้าเรียนคอร์ส</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Status Information Card -->
          <div class="card mb-4 status-card">
            <div class="card-header bg-gradient-cyan text-white">
              <h5 class="card-title mb-0">
                <i class="bi bi-sliders me-2"></i>สถานะและการยืนยัน
              </h5>
              <p class="mb-0 mt-1" style="font-size: 0.9rem; opacity: 0.9;">
                <i class="bi bi-info-circle me-1"></i>คุณสามารถเปลี่ยนสถานะได้โดยเลือกจากรายการด้านล่าง
              </p>
            </div>
            <div class="card-body p-4">
              <div class="row g-4">
                <!-- CPD Course Status (Read-only) -->
                <div class="col-md-6">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-bookmark-check me-2"></i>สถานะคอร์ส CPD:
                    </label>
                    <div class="status-display">
                      <span class="badge badge-lg"
                        [ngClass]="getCpdCourseStatusBadgeClass(cpdDetail.cpdCourseStatus?.name || getConfirmationStatusName(cpdDetail.cpdCourseStatusId))">
                        <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                        {{ cpdDetail.cpdCourseStatus?.name || getConfirmationStatusName(cpdDetail.cpdCourseStatusId) }}
                      </span>
                      <small class="text-muted d-block mt-1">
                        <i class="bi bi-lock-fill me-1"></i>สถานะนี้ไม่สามารถแก้ไขได้
                      </small>
                    </div>
                  </div>
                </div>

                <!-- Payment Status (Editable) -->
                <div class="col-md-6">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-credit-card me-2"></i>สถานะการชำระเงิน:
                    </label>
                    <div class="status-control">
                      <!-- แสดงอย่างเดียว: การปรับสถานะทำที่เมนู "ตรวจสอบการชำระเงิน" -->
                      <div class="status-badge-preview">
                        <span class="badge badge-lg"
                          [ngClass]="getCpdPaymentStatusBadgeClass(cpdDetail.cpdPaymentStatus.name)">
                          <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                          {{ cpdDetail.cpdPaymentStatus.name }}
                        </span>
                      </div>

                      <!-- Payment Slip Preview -->
                      <div class="mt-3" *ngIf="cpdDetail.paymentSlip">
                        <label class="d-block text-muted mb-2" style="font-size: 0.85rem;">
                          <i class="bi bi-receipt me-1"></i>หลักฐานการชำระเงิน
                        </label>
                        <div class="position-relative d-inline-block">
                          <img [src]="cpdDetail.paymentSlip" alt="หลักฐานการชำระเงิน" class="img-thumbnail"
                            style="max-width: 150px; max-height: 150px; object-fit: cover; cursor: pointer; border-radius: 8px;"
                            (click)="openImagePreview(cpdDetail.paymentSlip)">
                          <div class="position-absolute bottom-0 end-0 p-1 mb-1 me-1" style="pointer-events: none;">
                            <span class="badge bg-dark bg-opacity-75 rounded-pill"><i
                                class="bi bi-zoom-in me-1"></i>ดูรูป</span>
                          </div>
                        </div>
                        <div class="mt-2 d-flex flex-wrap gap-2">
                          <a [href]="cpdDetail.paymentSlip" target="_blank" class="btn btn-sm btn-outline-primary">
                            <i class="bi bi-box-arrow-up-right me-1"></i>เปิดรูปในแท็บใหม่
                          </a>
                        </div>
                      </div>

                      <!-- Transfer DateTime Display -->
                      <div *ngIf="cpdDetail.transferDateTime" class="mt-3 transfer-datetime-display">
                        <label class="d-block text-muted mb-2" style="font-size: 0.85rem;">
                          <i class="bi bi-clock-history me-1"></i>วันเวลาการโอนเงิน
                        </label>
                        <div class="transfer-datetime-box">
                          <div class="datetime-icon">
                            <i class="bi bi-calendar-check-fill"></i>
                          </div>
                          <div class="datetime-content">
                            <span class="datetime-text">{{ cpdDetail.transferDateTime }}</span>
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>

                <!-- Confirmation Status (Editable) -->
                <div class="col-md-6">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-shield-check me-2"></i>สถานะการยืนยัน:
                    </label>
                    <div class="status-control">
                      <select class="form-select form-select-lg status-select" [(ngModel)]="cpdDetail.cpdCourseStatusId"
                        (change)="updateConfirmationStatus(cpdDetail.cpdCourseStatusId)">
                        <option *ngFor="let status of confirmationStatusOptions" [value]="status.id">
                          {{ status.name }}
                        </option>
                      </select>
                      <div class="status-badge-preview mt-2">
                        <span class="badge badge-lg"
                          [ngClass]="getConfirmationStatusBadgeClass(cpdDetail.cpdCourseStatus?.name || getConfirmationStatusName(cpdDetail.cpdCourseStatusId))">
                          <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                          {{ cpdDetail.cpdCourseStatus?.name || getConfirmationStatusName(cpdDetail.cpdCourseStatusId)
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Completion Status (Editable) -->
                <div class="col-md-6">
                  <div class="status-item">
                    <label class="status-label">
                      <i class="bi bi-trophy me-2"></i>สถานะการเรียนจบ:
                    </label>
                    <div class="status-control">
                      <select class="form-select form-select-lg status-select" [(ngModel)]="cpdDetail.isCompleted"
                        (change)="updateCompletionStatus(cpdDetail.isCompleted)">
                        <option *ngFor="let option of completionOptions" [ngValue]="option.value">
                          {{ option.label }}
                        </option>
                      </select>
                      <div class="status-badge-preview mt-2">
                        <span class="badge badge-lg" [ngClass]="getCompletionBadgeClass(cpdDetail.isCompleted)">
                          <i class="bi bi-circle-fill me-2" style="font-size: 0.5rem;"></i>
                          {{ getCompletionText(cpdDetail.isCompleted) }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Status Update Info -->
              <div class="alert alert-info mt-4 mb-0" role="alert">
                <i class="bi bi-lightbulb me-2"></i>
                <strong>คำแนะนำ:</strong> การเปลี่ยนสถานะจะมีผลทันทีและบันทึกลงในระบบอัตโนมัติ
              </div>
            </div>
          </div>

          <!-- Registration Information -->
          <div class="card shadow-sm mb-4 registration-card">
            <div class="card-header bg-gradient-purple text-white">
              <h5 class="mb-0">
                <i class="bi bi-card-checklist me-2"></i>ข้อมูลการลงทะเบียน
              </h5>
            </div>
            <div class="card-body p-4">
              <div class="row g-4">
                <!-- Registration Date -->
                <div class="col-md-6">
                  <div class="registration-item">
                    <div class="registration-icon bg-gradient-primary">
                      <i class="bi bi-calendar-plus"></i>
                    </div>
                    <div class="registration-content">
                      <label class="registration-label">วันที่ลงทะเบียน</label>
                      <div class="registration-value">
                        <i class="bi bi-clock me-2 text-primary"></i>
                        {{ formatDate(cpdDetail.createdAt) }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Completion Date -->
                <div class="col-md-6">
                  <div class="registration-item">
                    <div class="registration-icon bg-gradient-success">
                      <i class="bi bi-calendar-check"></i>
                    </div>
                    <div class="registration-content">
                      <label class="registration-label">วันที่เรียนจบ</label>
                      <div class="registration-value">
                        <i class="bi bi-check-circle me-2 text-success"></i>
                        {{ cpdDetail.completedAt ? formatDate(cpdDetail.completedAt) : 'ยังไม่เรียนจบ' }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Created Date -->
                <div class="col-md-6">
                  <div class="registration-item">
                    <div class="registration-icon bg-gradient-info">
                      <i class="bi bi-file-earmark-plus"></i>
                    </div>
                    <div class="registration-content">
                      <label class="registration-label">วันที่สร้างข้อมูล</label>
                      <div class="registration-value">
                        <i class="bi bi-database me-2 text-info"></i>
                        {{ formatDate(cpdDetail.createdAt) }}
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Updated Date -->
                <div class="col-md-6">
                  <div class="registration-item">
                    <div class="registration-icon bg-gradient-warning">
                      <i class="bi bi-arrow-repeat"></i>
                    </div>
                    <div class="registration-content">
                      <label class="registration-label">วันที่อัปเดตข้อมูล</label>
                      <div class="registration-value">
                        <i class="bi bi-pencil-square me-2 text-warning"></i>
                        {{ formatDate(cpdDetail.updatedAt) }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Action Buttons -->
          <div class="d-flex gap-2 justify-content-end">
            <button type="button" class="btn btn-outline-secondary" (click)="goBack()">
              <i class="bi bi-arrow-left me-2"></i>กลับ
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Image Preview Modal -->
<div class="image-preview-modal" *ngIf="showImagePreview" (click)="closeImagePreview()">
  <div class="modal-backdrop"></div>
  <div class="modal-content-wrapper">
    <button type="button" class="btn-close-modal" (click)="closeImagePreview()">
      <i class="bi bi-x-lg"></i>
    </button>
    <div class="modal-image-container" (click)="$event.stopPropagation()">
      <img [src]="previewImageUrl" alt="หลักฐานการเรียน" class="preview-image">
    </div>
    <div class="modal-footer-info">
      <i class="bi bi-info-circle me-2"></i>
      <span>คลิกที่พื้นหลังหรือปุ่ม X เพื่อปิด</span>
    </div>
  </div>
</div>